export interface UploadthingClientFile {
  data?: UploadthingClientFile | null
  fileHash?: string | null
  file?: UploadthingClientFile | null
  key?: string | null
  name?: string | null
  size?: number | null
  type?: string | null
  ufsUrl?: string | null
  url?: string | null
}

export interface PublicUploadReference {
  capturedAt?: string | null
  durationSeconds?: number | null
  fileName: string | null
  fileSize: number | null
  fixityAlgorithm: "sha256" | null
  fixityChecksum: string | null
  languageHint?: string | null
  mimeType: string | null
  provider: "uploadthing"
  uploadKey: string | null
  uploadMetadata?: Record<string, unknown> | null
  url: string
}

export interface UploadReferenceOptions {
  capturedAt?: string | null
  durationSeconds?: number | null
  uploadMetadata?: Record<string, unknown> | null
}

function unwrapUploadthingClientFile(
  uploadedFile: UploadthingClientFile
): UploadthingClientFile {
  if (uploadedFile.data && typeof uploadedFile.data === "object") {
    return unwrapUploadthingClientFile(uploadedFile.data)
  }

  if (uploadedFile.file && typeof uploadedFile.file === "object") {
    return unwrapUploadthingClientFile(uploadedFile.file)
  }

  return uploadedFile
}

export function buildCapturedAtFromFile(file: File): string | null {
  if (!Number.isFinite(file.lastModified) || file.lastModified <= 0) {
    return null
  }

  return new Date(file.lastModified).toISOString()
}

export function serializeUploadReference(
  uploadedFile: UploadthingClientFile,
  options: UploadReferenceOptions = {}
): PublicUploadReference {
  const resolvedFile = unwrapUploadthingClientFile(uploadedFile)
  const url = resolvedFile.ufsUrl ?? resolvedFile.url ?? ""

  if (!url) {
    throw new Error("UploadThing did not return a usable file URL.")
  }

  const checksum = resolvedFile.fileHash?.trim() || null

  return {
    capturedAt: options.capturedAt ?? null,
    durationSeconds: options.durationSeconds ?? null,
    fileName: resolvedFile.name?.trim() || null,
    fileSize:
      typeof resolvedFile.size === "number" && Number.isFinite(resolvedFile.size)
        ? resolvedFile.size
        : null,
    fixityAlgorithm: checksum ? "sha256" : null,
    fixityChecksum: checksum,
    mimeType: resolvedFile.type?.trim() || null,
    provider: "uploadthing",
    uploadKey: resolvedFile.key?.trim() || null,
    uploadMetadata: options.uploadMetadata ?? null,
    url,
  }
}
